<script>
    import PlaygroundHelper from '../../scripts/playgroundhelper';
    export let features = [];
    export let placeholder = '';
    export let showHeadline = false;
</script>

<div>
    {#if features && features.length > 0}
        {#if showHeadline}
        Här finns:
        {/if}
        <ul>
            {#each features as feature}
                <li>{PlaygroundHelper.presentFeature(feature)}</li>
            {/each}
        </ul>
    {:else}
        {placeholder}
    {/if}
</div>

<style>
    ul {
        padding-left: 1.5em;
        margin: 0;
    }
</style>
